module.exports = __webpack_public_path__ + "img/Harbor_w@96x-8.44ab9643.png";